import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Button, Input, InputRef, Modal, Space } from 'antd'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { translate } from '../../../core'

export const PURCHASE_ORDER_DRAFT_STORAGE_KEY = 'purchaseOrderEntryDraft'

export const clearPurchaseOrderDraftStorage = () => {
  localStorage.removeItem(PURCHASE_ORDER_DRAFT_STORAGE_KEY)
  localStorage.removeItem('customItems')
  localStorage.removeItem('minMax')
  localStorage.removeItem('backOrder')
  localStorage.removeItem('minMaxData')
  localStorage.removeItem('backOrderData')
}

export const ReceivePurchaseOrderModal = ({
  open,
  closeMe,
}: {
  open: boolean
  closeMe: () => void
}) => {
  const navigate = useNavigate()
  const inputRef = useRef<InputRef>(null)
  const [number, setNumber] = useState('')
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (open) {
      setNumber('')
      setError(null)
    }
  }, [open])

  const handleFind = () => {
    const trimmed = number.trim()

    if (!trimmed) {
      setError(translate('enter_purchase_order_number'))
      return
    }

    if (!Number.isInteger(Number(trimmed))) {
      setError(translate('purchase_order_not_found'))
      return
    }

    setError(null)
    closeMe()
    navigate(`/purchase-order?number=${Number(trimmed)}`)
  }

  return (
    <Modal
      title={
        <Space>
          <ShoppingCartOutlined style={{ fontSize: 20 }} />
          {translate('receive_purchase_order_title')}
        </Space>
      }
      open={open}
      onCancel={closeMe}
      destroyOnClose
      afterOpenChange={(opened) => opened && inputRef.current?.focus()}
      footer={[
        <Button key="cancel" onClick={closeMe}>
          {translate('cancel')}
        </Button>,
        <Button
          key="find"
          type="primary"
          onClick={handleFind}
        >
          {translate('find_purchase_order')}
        </Button>,
      ]}
    >
      <div className="mt-3">
        <label className="d-block mb-1">
          {translate('purchase_order_nu_abbr')}
        </label>
        <Input
          ref={inputRef}
          value={number}
          onChange={(e) => {
            setNumber(e.target.value)
            if (error) setError(null)
          }}
          onPressEnter={handleFind}
        />
        {error && (
          <Alert
            className="mt-2"
            type="error"
            message={error}
            showIcon
          />
        )}
      </div>
    </Modal>
  )
}
